import React from "react";

const ArrowUpIcon = () => {
    return (
        <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.20835 11.2083C8.29169 11.2916 8.38891 11.3333 8.50002 11.3333C8.61113 11.3333 8.70835 11.2916 8.79169 11.2083L11.125 8.87496C11.25 8.74996 11.2811 8.60051 11.2184 8.42663C11.1561 8.25329 11.0278 8.16663 10.8334 8.16663H6.16669C5.97224 8.16663 5.84391 8.25329 5.78169 8.42663C5.71891 8.60051 5.75002 8.74996 5.87502 8.87496L8.20835 11.2083ZM8.50002 17.3333C7.34724 17.3333 6.26391 17.1144 5.25002 16.6766C4.23613 16.2394 3.35419 15.6458 2.60419 14.8958C1.85419 14.1458 1.26058 13.2638 0.823354 12.25C0.385576 11.2361 0.166687 10.1527 0.166687 8.99996C0.166687 7.84718 0.385576 6.76385 0.823354 5.74996C1.26058 4.73607 1.85419 3.85413 2.60419 3.10413C3.35419 2.35413 4.23613 1.76024 5.25002 1.32246C6.26391 0.885237 7.34724 0.666626 8.50002 0.666626C9.6528 0.666626 10.7361 0.885237 11.75 1.32246C12.7639 1.76024 13.6459 2.35413 14.3959 3.10413C15.1459 3.85413 15.7395 4.73607 16.1767 5.74996C16.6145 6.76385 16.8334 7.84718 16.8334 8.99996C16.8334 10.1527 16.6145 11.2361 16.1767 12.25C15.7395 13.2638 15.1459 14.1458 14.3959 14.8958C13.6459 15.6458 12.7639 16.2394 11.75 16.6766C10.7361 17.1144 9.6528 17.3333 8.50002 17.3333Z"
                fill="#0075FF"
            />
        </svg>
    );
};

export default ArrowUpIcon;
